module.exports = require("react-rnd");